import {api} from '../../../system/api';

export default {
	checkingInventory: (id) => api.get(`inventories/${id}/comparing`),
	comparingTrackingBill: id => api.get(`inventories/${id}/comparing-tracking-bill`)
};
